import { render, staticRenderFns } from "./ClientsPage.vue?vue&type=template&id=4cb54606&scoped=true"
import script from "./ClientsPage.vue?vue&type=script&lang=ts"
export * from "./ClientsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb54606",
  null
  
)

export default component.exports